// @flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// translit
import toTranslit from '../../util/cyrillic-to-translit';
// material
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { DefaultButton } from '../controls/button';
// Char counter
import TextCharCount from '../ui/charCounter';
// mutation
import * as CategoryAddMutation from '../../mutations/CategoryAddMutation';
import * as CategoryEditMutation from '../../mutations/CategoryEditMutation';
// style
import './category-editor.css';
import { sectionPath } from '../../lib/config';

type Props = {
	category: Object,
	relay: Object,
	history: Object,
};

type State = {
	id?: string,
	name: string,
	slug?: string,
	section: string,
	hidden: boolean,
	seoTitle?: string,
	seoDescription?: string,
	seoKeywords?: string,
};

const styleUnderline = {
	bottom: 5,
};

class CategoryEditor extends React.Component<Props, State> {
	state = { ...this.props.category };

	onTitleChanged = (event: any, newValue: string) => {
		this.setState({
			name: newValue,
			slug: toTranslit(newValue),
		});
	};

	onSlugChanged = (newValue: string) => {
		this.setState({
			slug: toTranslit(newValue),
		});
	};

	save = (value: Object) => {
		const callback = (error: ?any, categoryId: ?string) => {
			if (error != null) {
				alert(`error saving topic: ${error}`);
				return;
			}

			if (categoryId) {
				this.props.history.replace(`/category/${categoryId}`);
			}
		};

		if (this.state.id) {
			CategoryEditMutation.commit(this.props.relay.environment, value, (error, id) => callback(error, id));
		} else {
			CategoryAddMutation.commit(this.props.relay.environment, value, (error, id) => callback(error, id));
		}
	};
	render() {
		return (
			<section className="category-editor">
				<Paper className="category-editor--wrapper">
					<h3 className="category-editor--title">Рубрика</h3>
					<section className="category-editor--fields">
						<TextField
							className="category-editor--field"
							floatingLabelText="Название"
							value={this.state.name}
							maxLength="150"
							fullWidth
							errorText={this.state.name === null || this.state.name.length === 0 ? 'это поле нужно заполнить' : null}
							onChange={(event, value) => this.onTitleChanged(event, value)}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
						<TextCharCount maxChar={150} currentChar={this.state.name.length} />

						<TextField
							className="category-editor--field"
							floatingLabelText="Slug"
							value={this.state.slug}
							maxLength="150"
							fullWidth
							errorText={this.state.slug === null || this.state.slug === '' ? 'это поле нужно заполнить' : null}
							onChange={(event, value) => this.onSlugChanged(value)}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
						<TextCharCount maxChar={150} currentChar={this.state.slug ? this.state.slug.length : 0} />

						<TextField
							className="category-editor--field"
							floatingLabelText="SEO title"
							value={this.state.seoTitle}
							maxLength="140"
							fullWidth
							onChange={(e, v) => this.setState({ seoTitle: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>

						<TextField
							className="category-editor--field"
							floatingLabelText="SEO description"
							value={this.state.seoDescription}
							fullWidth
							multiLine
							rows={1}
							rowsMax={4}
							onChange={(e, v) => this.setState({ seoDescription: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>

						<TextField
							className="category-editor--field"
							floatingLabelText="SEO keywords"
							value={this.state.seoKeywords || ''}
							fullWidth
							onChange={(e, v) => this.setState({ seoKeywords: v })}
							floatingLabelFixed
							underlineStyle={styleUnderline}
						/>
					</section>
				</Paper>
				<aside className="category-editor--sidebar">
					<div className="button__bottom">
						<SelectField
							floatingLabelText="Статус"
							value={this.state.hidden}
							onChange={(event, index, isChecked) => {
								this.setState({ hidden: isChecked });
							}}
						>
							<MenuItem value={false} primaryText="Видна" />
							<MenuItem value primaryText="Скрыта" />
						</SelectField>
						<DefaultButton onClick={() => this.save(this.state)} />
					</div>
					<div className="button__bottom_2">
						<SelectField
							floatingLabelText="Раздел"
							errorText={this.state.section === null || this.state.section === '' ? 'Необходимо заполнить поле' : null}
							value={this.state.section}
							onChange={(event, index, section) => {
								this.setState({ section: section });
							}}
						>
							<MenuItem value={sectionPath.news} primaryText="78 Новости" />
							<MenuItem value={sectionPath.article} primaryText="Статьи" />
						</SelectField>
					</div>
				</aside>
			</section>
		);
	}
}

export default withRouter(
	createFragmentContainer(
		CategoryEditor,
		graphql`
			fragment CategoryEditor_category on Category {
				id
				name
				slug
				hidden
				section
				section
				seoTitle
				seoDescription
				seoKeywords
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/categories/CategoryEditor.js